import pro1 from "../assets/Commerce Hub.png";
import pro2 from "../assets/Ezra Seminary.png";
import pro3 from "../assets/BookLoop.png";
import pro4 from "../assets/Kerchanshe.png";
import pro5 from "../assets/Revo.png";
import pro6 from "../assets/DNA.png";
import pro7 from "../assets/Logic TrueCare.png";
import pro8 from "../assets/T&T Security Services.png";
import pro9 from "../assets/Belimuno Jobs.png";

const ProjectCardData = [
  {
    imgsrc: pro4,
    title: "Kerchanshe Coffee",
    text: "A coffee export website built using Next.js for the frontend and Strapi as the backend.",
    view: "https://kerchanshecoffee.com/",
    source: "",
  },
  {
    imgsrc: pro9,
    title: "Belimuno Jobs",
    text: "A job portal website designed to connect job seekers with employers.",
    view: "https://belimunojobs.com/",
    source: "",
  },
  {
    imgsrc: pro2,
    title: "EZRA Seminary",
    text: "A comprehensive E-learning platform built with MERN stack tech.",
    view: "https://ezraseminary.org/",
    source: "https://github.com/EzraSeminary?tab=repositories",
  },
  {
    imgsrc: pro5,
    title: "Revo Solutions",
    text: "A dynamic portfolio website built with React, Node.js, Express, and MySQL.",
    view: "https://revosolutionplc.com/",
    source: "https://github.com/yeabtsega45/Revo-Solutions",
  },
  {
    imgsrc: pro6,
    title: "DNA Lions Accounting Firm",
    text: "A modern accounting firm website built with React and integrated with Web3forms, deployed on cPanel.",
    view: "https://dnalions.com/",
    source: "https://github.com/yeabtsega45/DNA-Lions",
  },
  {
    imgsrc: pro7,
    title: "Logic TrueCare",
    text: "A responsive service listing website built with React and integrated with Web3forms.",
    view: "https://logictruecare.com/",
    source: "",
  },
  {
    imgsrc: pro8,
    title: "T and T Security Services LLC",
    text: "A security services website built with React and deployed on cPanel, featuring optimized image rendering.",
    view: "https://www.ttsecurityservicesllc.com/",
    source: "https://github.com/yeabtsega45/T-and-T-Security-Services-LLC",
  },
  {
    imgsrc: pro3,
    title: "BookLoop",
    text: "A book rental platform leveraging the MERN stack to facilitate the renting and management of books.",
    view: "https://bookrent.netlify.app/",
    source: "https://github.com/yeabtsega45/BookLoop",
  },
  {
    imgsrc: pro1,
    title: "Commerce Hub",
    text: "ECommerce website built using React.",
    view: "https://yeabtsega-ecommerce.netlify.app/",
    source: "https://github.com/yeabtsega45/Commerce-Hub",
  },
];

export default ProjectCardData;
